import {Space, Modal, Form, Input, Button, Select, Card, Table, message, Tooltip, Tag} from "antd";
import { SearchOutlined, ReloadOutlined, PlusOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import ShopSelect from '../../../components/BaseInfoSelects/StoreSelectBase'
import service from "../../../@services";
import { useEffect, useState } from "react";
import * as Utils from '../../../@utils'
import AuthComponent from "../../../components/AuthComponent";
import EditActivityGroup from "./components/editActivityGroup";
import GoodsList from "./components/goodsList";
import { activityStatusMap } from '../config'
import TimeDurationFormItem from "../../../components/TimeDurationFormItem";
const basicDurationKeys = ['beginCreateTime', 'endCreateTime']
export default function ActivityGroup(props) {
    const [form] = Form.useForm();
    const [activityGroupVisible, setActivityGroupVisible] = useState(false)
    const [editVisible, setEditVisible] = useState(false)
    const [editId, setEditId] = useState('')
    const [goodVisible, setGoodVisible] = useState(false)
    const [goodData, setGoodData] = useState([])
    const [selectedRowKeys, onSelectChange] = useState([])
    const [storeId,onSelectStore] = useState("")
    const [tabActiveKey, setTabActiveKey] = useState()
    const [loading, setLoading] = useState(false)
    const [tableData, setTableData] = useState([])
    const [pagination, setPagination] = useState({current: 1,pageSize: 10,})
    useEffect(() => {
        onSearch()
    }, [tabActiveKey,storeId]);
    const setDefaultStore = (res)=>{
        form.setFieldsValue({
            storeCode: res.storeCode
        })
        onSelectStore(res.storeCode)
    }
    const onSearch = () => {
        if(!storeId){
            // message.warning('请选择门店');
            return
        }
        const params = Object.assign({},form.getFieldsValue(),{ pageIndex: 1, pageSize: 10})
        fetchData(params)
    }
    const onReset = () => {
        form.resetFields();
    };
    const handleTableChange = (pagination) => {
        setPagination(pagination)
        const params = Object.assign({},form.getFieldsValue(),{ pageIndex: pagination.current, pageSize: pagination.pageSize})
        fetchData(params)
    }
    const fetchData = async (params) => {
        setLoading(true)
        const data = await service.activity.getActivityGroupList(params)
        setLoading(false)
        if(data){
            setTableData(data.result)
            setPagination({
                current: data.pageIndex,
                pageSize: data.pageSize,
                total: data.recordCount
            })
        }
    }
    const pushStore = async (skuIds) => {
        await service.product.createForStore({skuIds,storeIds:[storeId]})
        setActivityGroupVisible(false)
        message.success('操作成功');
        onSearch()
    };
    const deleteActivity = async (skuId) => {
        Modal.confirm({
            title: '提示',
            icon: <ExclamationCircleOutlined />,
            content: '确认要删除吗？',
            okText: '确认',
            cancelText: '取消',
            onOk: async ()=>{
                await service.activity.deleteGroup(skuId)
                message.success('操作成功');
                onSearch()
            }
        });
    };
    const addActivityGroup = () => {
        if(!storeId){
            message.warning('请选择门店');
            return
        }
        props.history.push(`/activity/group/edit?storeId=${storeId}`)
        // setActivityGroupVisible(true)
    }
    const viewActivity = (skuId) => {
        props.history.push(`/activity/group/detail?actId=${skuId}`)
    };
    const auditActivity = (skuId) => {
        setEditId(skuId)
        setEditVisible(true)
    }
    const ClickOk = async ()=>{
        await service.activity.auditActivityGroup(editId)
        message.success('操作成功');
        setEditVisible(false)
        onSearch()
    }
    const ClickCancel = async ()=>{
        await service.activity.rejectActivityGroup(editId)
        message.success('驳回成功');
        setEditVisible(false)
        onSearch()
    }
    const finishActivity = (skuId) => {
        Modal.confirm({
            title: '提前结束',
            icon: <ExclamationCircleOutlined />,
            content: '活动结束后若商品数量未达到团购最低数量订单将自动取消',
            okText: '确定',
            cancelText: '取消',
            onOk: async ()=>{
                await service.activity.finishActivityGroup(skuId)
                message.success('操作成功');
                onSearch()
            }
        });
    }
    const showGoodsDetail = async (skuId) => {
        setLoading(true)
        const data = await service.activity.getGoodsDetail(skuId)
        setLoading(false)
        if(data){
            setGoodData(data)
        }
        setGoodVisible(true)
    }
    const exportProduct = async () => {
        const params = Object.assign({},form.getFieldsValue())
        const file = await service.product.exportStoreProduct(params)
        const filename = '门店商品报表' + Utils.parseTime(Date.parse(new Date())) + '.xlsx'
        Utils.download(file, filename)
    };
    const columns = [
        {
            title: '活动ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: '活动名称',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            render: (text) => {
                return(
                    <div>
                    {activityStatusMap && activityStatusMap.map((item,index) => item.value === text ? (
                        <Tag color={item.color} key={index}>{item.label}</Tag> ): '')
                    }
                    </div>
                )
            }
        },
        {
            title: '活动有效期',
            dataIndex: 'validBeginTime',
            key: 'validBeginTime',
            render: (text,record) => {
                return(
                    <div>
                        {record.validBeginTime  + '至' + record.validEndTime}
                    </div>
                )
            }
        },
        {
            title: '活动订单数',
            dataIndex: 'orderCount',
            className: 'redColor',
            key: 'orderCount',
        },
        {
            title:
                <div>
                    商品数量
                    <Tooltip placement="topLeft" title="实时统计已团商品总数量" arrowPointAtCenter>
                        <ExclamationCircleOutlined style={{ marginLeft: '10px' }}/>
                    </Tooltip>
                </div>
            ,
            dataIndex: 'productCount',
            key: 'productCount',
        },
        {
            title: '成团人数',
            dataIndex: 'userCount',
            key: 'userCount',
        },
        {
            title: '销售金额',
            dataIndex: 'salesAmount',
            key: 'salesAmount',
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
        },
        {
            title: '操作',
            width: '210px',
            dataIndex: '',
            key: 'x',
            render: (text,record,index) => (
                <Space style={{flexWrap: 'wrap'}}>
                    <AuthComponent authKey="/activity/group/detail/{actId}"><Button onClick={()=>viewActivity(record.id)} type="link">查看</Button></AuthComponent>
                    {
                        record.status === 'UN_AUDIT'
                          ?
                          <Space>
                              <AuthComponent authKey="/activity/group/audit/{actId}"><Button
                                onClick={() => auditActivity(record.id)} type="link">审核</Button></AuthComponent>
                              <AuthComponent authKey="/activity/group/delete/{actId}"><Button
                                onClick={() => deleteActivity(record.id)} type="link">删除</Button></AuthComponent>
                          </Space>
                          : ''
                    }
                    {
                        ['UN_START', 'RUNNING'].includes(record.status)
                          ?
                          <AuthComponent authKey="/activity/group/finish/{actId}"><Button onClick={()=>finishActivity(record.id)} type="link">提前结束</Button></AuthComponent>
                          : ''
                     }
                    {
                        ['FINISHED', 'RUNNING'].includes(record.status)
                          ?
                          <AuthComponent authKey="/activity/group/goods-inventory/{actId}"><Button onClick={()=>showGoodsDetail(record.id)} type="link">备货清单</Button></AuthComponent>
                          : ''
                    }
                    {
                        !['UN_AUDIT', 'UN_START', 'RUNNING', 'FINISHED'].includes(record.status)?
                        <AuthComponent authKey="/activity/group/delete/{actId}"><Button onClick={()=>deleteActivity(record.id)} type="link">删除</Button></AuthComponent>: ''
                    }
                </Space>
            ),
        },
    ];
    return (
        <>
            <div style={activityGroupVisible ? { height: 0, width: 0, overflow: 'hidden' } : {}}>
                <Card>
                    <Form
                        wrapperCol={{ style: { marginBottom: 20 } }}
                        layout='inline'
                        labelCol={{ style: { width: 90, textAlign: 'right' } }}
                        form={form}
                    >
                        <Form.Item name="storeCode" label="所属门店">
                            <ShopSelect style={{ width: 200 }} keyVal='storeCode' OnOptionsLoad={setDefaultStore} onChange={onSelectStore} />
                        </Form.Item>
                        <Form.Item name="status" label="活动状态">
                            <Select style={{ width: 150 }} placeholder="请选择活动状态" allowClear>
                                {activityStatusMap &&
                                activityStatusMap.map(item => (
                                    <Select.Option key={item.value} value={item.value}>
                                        {item.label}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item name="actInfo" label="活动信息">
                            <Input style={{ width: 200 }} placeholder="请输入活动ID或名称" />
                        </Form.Item>
                        <TimeDurationFormItem
                            keys={basicDurationKeys}
                            label='创建时间'
                            isShowTime={true}
                            dateFormatList={'YYYY-MM-DD HH:mm:ss'}
                            form={form}
                        />
                        <Form.Item>
                            <AuthComponent authKey="/activity/group/search">
                                <Button type="primary" ghost icon={<SearchOutlined />} onClick={onSearch}>查询</Button>
                            </AuthComponent>
                        </Form.Item>
                        <Form.Item>
                            <AuthComponent authKey="/activity/group/search">
                                <Button type="primary" ghost icon={<ReloadOutlined />} onClick={onReset}>重置</Button>
                            </AuthComponent>
                        </Form.Item>
                    </Form>
                </Card>
                <Space style={{ display: "flex", background: "#ffffff", padding: "15px", marginBottom: "-10px", marginTop: '20px' }}>
                    <AuthComponent authKey="/activity/group/create">
                        <Button type="primary" onClick={addActivityGroup} icon={<PlusOutlined />}>新建团购活动</Button>
                    </AuthComponent>
                </Space>
                <Table
                    rowKey={record=>record.id}
                    dataSource={tableData}
                    pagination={pagination}
                    loading={loading}
                    columns={columns}
                    onChange={handleTableChange}
                />
            </div>

            <Modal
                title="活动上架审核"
                visible={editVisible}
                closable={true}
                onCancel={()=> setEditVisible(false)}
                footer={[
                    <AuthComponent authKey="/activity/group/reject/{actId}">
                        <Button key="back" onClick={ClickCancel}>驳回</Button>
                    </AuthComponent>,
                    <Button key="submit" type="primary" loading={loading} onClick={ClickOk}>
                        通过
                    </Button>, ]}
            >
                <p>上架审核通过后活动生效</p>
            </Modal>

            <GoodsList
                visible={goodVisible}
                dataList={goodData}
                close={()=>{setGoodVisible(false)}}
            />
        </>
    );
}
